<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Facturas del cliente</h2></v-toolbar-title></pre>
        </v-toolbar>

        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="facturas"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            @click:row="
                (item) =>
                    $router.push(
                        `guardar-${item.nota == 1 ? 'nota' : 'factura'}?id=${
                            item.id
                        }`
                    )
            "
            :item-class="
                () => {
                    return 'pointer';
                }
            "
            :sort-desc="[false]"
        >
            <template v-slot:item.obra="{ item }">
                <span>{{ formatObra(item) }}</span>
            </template>
            <template v-slot:item.fecha="{ item }">
                <span v-if="item.fecha">{{ item.fecha | format_date }}</span>
                <span v-else>—</span>
            </template>
            <template v-slot:item.fecha_vencimiento="{ item }">
                <span v-if="item.fecha_vencimiento">{{
                    item.fecha_vencimiento | format_date
                }}</span>
                <span v-else>—</span>
            </template>
            <template v-slot:item.metodo_pago="{ item }">
                <span>{{ metodoPagoNombre(item) }}</span>
            </template>
            <template v-slot:item.total="{ item }">
                <span>{{ totalConIva(item) | format_precio }}</span>
            </template>
            <template v-slot:item.cobrado="{ item }">
                <span>{{ item.cobrado | format_precio }}</span>
            </template>
            <template v-slot:item.pendiente="{ item }">
                <span>{{ (totalConIva(item) - (parseFloat(item.cobrado) || 0)) | format_precio }}</span>
            </template>
            <template v-slot:item.pdf="{ item }">
                <a
                    target="_blank"
                    :href="`/api/pdf-factura/${item.id}`"
                    @click.stop=""
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>
            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{
                        path: `/guardar-factura-${
                            $route.meta.rol == 1 ? 'potencial' : 'cliente'
                        }?id=${item.id}`,
                    }"
                    class="action-buttons"
                    @click.native.stop=""
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </router-link>
                <v-icon
                    @click.stop="openSaveDialog(item.id, importePendienteItem(item))"
                    small
                    class="mr-2"
                    color="black"
                    style="font-size: 25px"
                    title="ABONAR"
                    >mdi-cash</v-icon
                >
            </template>
        </v-data-table>

        <v-dialog v-model="save_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar abono
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12" md="6">
                            <date-select v-model="abono.fecha" label="Fecha">
                            </date-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="abono.importe"
                                type="number"
                                label="Importe"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="save_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="SaveAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import dateSelect from "../../../components/general/dateSelect.vue";

export default {
    components: { dateSelect },
    props: ["facturas"],
    data() {
        return {
            save_dialog: false,
            abono: {},
            search: "",
            headers: [
                { text: "Nº Factura", value: "nro", sortable: false },
                {
                    text: "Nº Presupuesto",
                    value: "presupuestos_ids",
                    sortable: false,
                },
                {
                    text: "Obra",
                    value: "obra",
                    sortable: false,
                },
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: false,
                },
                {
                    text: "Vto",
                    value: "fecha_vencimiento",
                    sortable: false,
                },
                {
                    text: "Método de pago",
                    value: "metodo_pago",
                    sortable: false,
                },
                { text: "Importe", value: "total", sortable: false },
                { text: "Cobrado", value: "cobrado", sortable: false },
                {
                    text: "Pendiente de cobro",
                    value: "pendiente",
                    sortable: false,
                },

                { text: "PDF", value: "pdf", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],

            Clientes: [],
        };
    },
    created() {},
    methods: {
        importePendienteItem(item) {
            const t = this.totalConIva(item);
            const c = parseFloat(item.cobrado) || 0;
            return Math.round((t - c) * 100) / 100;
        },
        openSaveDialog(id_factura, importe_pendiente) {
            this.save_dialog = true;
            this.abono = {
                id_factura: id_factura,
                importe: importe_pendiente,
                fecha: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                )
                    .toISOString()
                    .substr(0, 10),
            };
        },
        SaveAbono() {
            axios.post(`api/save-abono`, this.abono).then(
                () => {
                    this.$toast.sucs("Abono guardado con éxito");
                    this.save_dialog = false;
                    this.$emit("abono-guardado");
                },
                (err) => {
                    if (err.response?.status === 400) {
                        this.$custom_error(
                            err.response.data.mensaje || "Error al guardar"
                        );
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                }
            );
        },
        // Total con IVA: en facturas (nota=0) es base * (1 + iva/100); en notas se usa el total tal cual
        totalConIva(item) {
            if (!item) return 0;
            const base = parseFloat(item.total) || 0;
            const iva = parseFloat(item.iva) || 0;
            if (item.nota === 1) return Math.round(base * 100) / 100;
            return Math.round(base * (1 + iva / 100) * 100) / 100;
        },
        formatObra(item) {
            if (!item) return "—";
            const o = item.orden || item.Orden;
            if (!o) return "—";
            const nro = o.nro_orden || "";
            const nom = o.nombre ? " – " + o.nombre : "";
            return nro ? nro + nom : "—";
        },
        metodoPagoNombre(item) {
            if (!item) return "—";
            const m = item.metodo_pago || item.MetodoPago;
            return (m && m.nombre) || "—";
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
